import { useQuery, QueryHookOptions } from '@apollo/react-hooks';
import { GET_EMAIL_RESOURCES_FOR_CLIENT_QUERY } from '@frontend/app/queries';
import {
  GetEmailResourcesForClientQuery,
  GetEmailResourcesForClientQueryVariables,
} from '@frontend/app/queries/types/GetEmailResourcesForClientQuery';

type TOptions = QueryHookOptions<GetEmailResourcesForClientQuery, GetEmailResourcesForClientQueryVariables>;

export const useGetEmailResourcesForClientQuery = (options: TOptions) =>
  useQuery<GetEmailResourcesForClientQuery, GetEmailResourcesForClientQueryVariables>(
    GET_EMAIL_RESOURCES_FOR_CLIENT_QUERY,
    options,
  );
